import bank from '../../assets/icons/bank.svg'
import clinic from '../../assets/icons/clinic.svg'
import company from '../../assets/icons/company.svg'
import school from '../../assets/icons/school.svg'
import GYM from '../../assets/icons/GYM.svg'
import farm from '../../assets/icons/farm.svg'
import market from '../../assets/icons/market.svg'
import pizza from '../../assets/icons/pizza.svg'
import programmer from '../../assets/icons/programmer.svg'
import factory from '../../assets/icons/factory.svg'



export const icons = {
    bank,
    clinic,
    company,
    school,
    GYM,
    farm,
    market,
    pizza,
    programmer,
    factory
}


export type Place = 'bank' | 'clinic' | 'company' | 'school' 
| 'GYM' | 'farm' | 'market' | 'pizza' | 'programmer' | 'factory'